import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RepatriationsTransactionsObjectDialog from './RepatriationsTransactionsObjectDialog';
import InternalRepatriationsTransactionsDeleteDialog
  from '../../delete/containers/InternalRepatriationsTransactionsDeleteDialog';

class RepatriationsTransactionsObject extends Component {
  render() {
    return (
      <div>
        <RepatriationsTransactionsObjectDialog
          row={this.props}
          closeDialog={this.props.closeDialog}
          openDialog={this.props.openDialog}
          refreshTransactions={this.props.refreshTransactions}
          refreshHistories={this.props.refreshHistories}
        />
      </div>
    );
  }
}

RepatriationsTransactionsObject.propTypes = {
  closeDialog: PropTypes.func.isRequired,
  openDialog: PropTypes.func.isRequired,
  refreshTransactions: PropTypes.func,
  refreshHistories: PropTypes.func,
};

export default RepatriationsTransactionsObject;
